/*=====================================
    下載發票媒體申報檔 modal

    Author: Gray
    createtime: 2018 / 01 / 22
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import { DialogStyle } from 'stylecomponents';
import classNames from "classnames";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';

/*--------------------------
    Main Component
--------------------------*/
class DownloadTaxMediaDialog extends Component {

	// ------------------------------
	// constructor
	// ------------------------------
	constructor(props) {

        super(props);

        this.state = {
            startDay: '',
            endDay: '',
            isNoSelectTimeError: false,
            isStartDayEmpty: false,
            isEndDayEmpty: false,
        };

        this.onDaySelectChange = this.onDaySelectChange.bind(this);
        this.renderCustomDayPickerOverlay = this.renderCustomDayPickerOverlay.bind(this);
        this.closeDownloadTaxMediaDialog = this.closeDownloadTaxMediaDialog.bind(this);
        this.dnldInvoiceTaxMedia1 = this.dnldInvoiceTaxMedia1.bind(this);
        this.dnldInvoiceTaxMedia2 = this.dnldInvoiceTaxMedia2.bind(this);
    }

    // ------------------------------
    // 時間變動
    // ------------------------------
    onDaySelectChange(selectedDay, modifiers, statekey) {

        const dayValue = formatDate(selectedDay, 'YYYY/MM/DD');
        const value = new Date(dayValue);
        
        this.setState({
            [statekey]: value,
        });
    }

    // ------------------------------
    // 將 DatePicker style改為absolute
    // ------------------------------
    renderCustomDayPickerOverlay({ classNames, selectedDay, children }) {

        return (
            <div className={classNames.overlayWrapper} style={{ position: 'absolute', lineHeight: 'normal' }}>
                <div className={classNames.overlay}>
                    {children}
                </div>
            </div>
        );
    }

    // ------------------------------
    // 關閉 modal
    // ------------------------------
    closeDownloadTaxMediaDialog() {

    	this.props.invoiceActions.closeDownloadTaxMediaDialog();
    }

    // ------------------------------
    // 下載1
    // ------------------------------
    dnldInvoiceTaxMedia1() {

    	const {
    	    startDay,
    	    endDay,
    	} = this.state;

    	var starttime = -1;
    	var endtime = -1;

    	var new_startDay = new Date(startDay);
        var new_endDay = new Date(endDay);


        if(!isNaN(new_startDay)) {
            starttime = new_startDay.getTime();
        }

        if(!isNaN(new_endDay)) {
            endtime = new_endDay.getTime();
        }


        var isStartDayEmpty = starttime === -1;
        var isEndDayEmpty = endtime === -1;

        if(isStartDayEmpty || isEndDayEmpty) {
            this.setState({
                isStartDayEmpty: isStartDayEmpty,
                isEndDayEmpty: isEndDayEmpty,
            });
            return;
        }

        this.setState({
            isStartDayEmpty: isStartDayEmpty,
            isEndDayEmpty: isEndDayEmpty,
        });

    	var downloadUrl1 = this.props.invoiceActions.dnldInvoiceTaxMedia1(starttime, endtime);

    	window.open(downloadUrl1);
    }

    dnldInvoiceTaxMedia2() {

    	const {
    	    startDay,
    	    endDay,
    	} = this.state;

    	var starttime = -1;
    	var endtime = -1;

    	var new_startDay = new Date(startDay);
        var new_endDay = new Date(endDay);


        if(!isNaN(new_startDay)) {
            starttime = new_startDay.getTime();
        }

        if(!isNaN(new_endDay)) {
            endtime = new_endDay.getTime();
        }


        var isStartDayEmpty = starttime === -1;
        var isEndDayEmpty = endtime === -1;

        if(isStartDayEmpty || isEndDayEmpty) {
            this.setState({
                isStartDayEmpty: isStartDayEmpty,
                isEndDayEmpty: isEndDayEmpty,
            });
            return;
        }

        this.setState({
            isStartDayEmpty: isStartDayEmpty,
            isEndDayEmpty: isEndDayEmpty,
        });

    	var downloadUrl2 = this.props.invoiceActions.dnldInvoiceTaxMedia2(starttime, endtime);

    	window.open(downloadUrl2);
    }    

        // ------------------------------
    // 下載1
    // ------------------------------
    dnldInvoiceReport() {

    	const {
    	    startDay,
    	    endDay,
    	} = this.state;

    	var starttime = -1;
    	var endtime = -1;

    	var new_startDay = new Date(startDay);
        var new_endDay = new Date(endDay);


        if(!isNaN(new_startDay)) {
            starttime = new_startDay.getTime();
        }

        if(!isNaN(new_endDay)) {
            endtime = new_endDay.getTime();
        }


        var isStartDayEmpty = starttime === -1;
        var isEndDayEmpty = endtime === -1;

        if(isStartDayEmpty || isEndDayEmpty) {
            this.setState({
                isStartDayEmpty: isStartDayEmpty,
                isEndDayEmpty: isEndDayEmpty,
            });
            return;
        }

        this.setState({
            isStartDayEmpty: isStartDayEmpty,
            isEndDayEmpty: isEndDayEmpty,
        });

    	var downloadUrl1 = this.props.invoiceActions.dnldInvoiceReport(starttime, endtime);

    	window.open(downloadUrl1);
    }


    // ------------------------------
    // render
    // ------------------------------
    render() {

    	const {
    	    startDay,
    	    endDay,
            isStartDayEmpty,
            isEndDayEmpty,
    	} = this.state;

    	const startDayValue = startDay ? formatDate(startDay, 'YYYY/MM/DD') : '';
    	const endDayValue = endDay ? formatDate(endDay, 'YYYY/MM/DD') : '';

    	return (
    		<DialogStyle.Content
                className="download-tax-media-dialog"
                // style props
                width="600px"
                maxWidth="600px"
                padding="0"
                borderRadius="3px"
                backgroundColor="#fff"
                // dialog props
                visible={true}
                animation="zoom"
                maskAnimation="fade"
                animationDuration={250}
                closable={false}
                maskClosable={true}
                keyboard={true}
                onClose={this.closeDownloadTaxMediaDialog}
            >
		        <div className="download-modal-content">
					<h3 className="title">下載發票媒體申報檔</h3>
					
					<div className="form has-padding">
						<div className="form-row">
							<div className="form-col">
								<div className="form-item">
									<h5 className="title">時間</h5>
									<DayPickerInput
									    overlayComponent={this.renderCustomDayPickerOverlay}
									    onDayChange={(selectedDay, modifiers) => this.onDaySelectChange(selectedDay, modifiers, 'startDay')}
									    formatDate={formatDate}
									    parseDate={parseDate}
									    format="YYYY/MM/DD"
									    value={startDayValue}
									    dayPickerProps={{
									        selectedDays: startDay,
									    }}
									    placeholder="起"
									    inputProps={{
                                            className: classNames("date", {
                                               'error': isStartDayEmpty
                                            })
                                        }}
									/>
									<span className="line"></span>
									<DayPickerInput
									    overlayComponent={this.renderCustomDayPickerOverlay}
									    onDayChange={(selectedDay, modifiers) => this.onDaySelectChange(selectedDay, modifiers, 'endDay')}
									    formatDate={formatDate}
									    parseDate={parseDate}
									    format="YYYY/MM/DD"
									    value={endDayValue}
									    dayPickerProps={{
									        selectedDays: endDay,
									    }}
									    placeholder="訖"
									    inputProps={{
									    	className: classNames("date", {
                                               'error': isEndDayEmpty
                                            })
									    }}
									/>
								</div>
							</div>
						</div>                        
						<div className="form-row text-right">
                        
							<div className="form-col">
                                {isStartDayEmpty || isEndDayEmpty ?
                                    <div className="error">請選擇時間區間 </div>
                                    :
                                    null
                                }
								<div 
									className="button blue" 
									onClick={() => this.dnldInvoiceReport()}
								>
									下載發票報表
								</div>

								<div 
									className="button blue" 
									onClick={() => this.dnldInvoiceTaxMedia1()}
								>
									下載媒體申報檔一
								</div>
								<div 
									className="button blue" 
									onClick={() => this.dnldInvoiceTaxMedia2()}
								>
									下載媒體申報檔二
								</div>

								<div className="button" onClick={() => this.closeDownloadTaxMediaDialog()}>取消</div>
							</div>
						</div>
					</div>
		        </div>                
            </DialogStyle.Content>
    	)
    }
}

const mapStateToProps = function(state) {
    return {
    };
};

const mapActionToProps = function(dispatch) {
    return {
        invoiceActions: bindActionCreators(actionCreators.invoiceActionCreators, dispatch),
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {
    withRef: true
})(DownloadTaxMediaDialog);


// WEBPACK FOOTER //
// ./src/components/dialog/DownloadTaxMediaDialog.jsx